module.exports = __webpack_public_path__ + "static/media/default—banner@2x.4dd200af.png";